module.exports = {
	"192": {
		"name": "Uzbekistan",
		"short": "UZ",
		"mask": "+998",
		"length": 9
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/fast-join-countries/uz.json
// module id = 1821
// module chunks = 2